export const subscriptionProductProductReducer = (state = {loading: true, subscriptionProduct: null, errorSubscriptionProduct: null, subscriptionProducts: []} , action) => {
    switch (action.type) {
        case 'SUBSCRIPTION_PRODUCT_LOADING':
            return {
                ...state, loading: true
            }
        case 'SUBSCRIPTION_PRODUCT_GETALL_SUCCESS':
            return {
                ...state,
                loading: false,
                subscriptionProducts: action.payload
            }
        case 'SUBSCRIPTION_PRODUCT_ERROR':
            return {
                ...state,
                loading: false,
                errorSubscriptionProduct: action.payload
            }
        case 'SUBSCRIPTION_PRODUCT_ERROR_RESET':
            return {
                ...state, errorSubscriptionProduct: null
            }
        default:
            return state
    }
}

